import { normalizeHostFieldValue } from '../configurable-step/hostFieldContract';
import type { ComponentBindingMeta } from './types';

/**
 * Hen-ui `MultiSelect` is strictly controlled: it reads `selectedValues`
 * and emits the next array on `onChange`. DSM form state is a flat
 * string, same contract as `ToggleGroup` multi-select (`"keyA,keyB"`).
 *
 * The read side always returns an array. An absent or blank key becomes
 * `[]` so the component never sees `undefined` (`selectedValues.length`
 * would throw, and a click would look like a no-op).
 *
 * The selection cap is the component's own `maxSelectable` prop. A
 * rejected extra pick never calls `onChange`, so it never reaches
 * form state.
 */
export function multiSelectToFormState(value: unknown): string {
  const normalized = normalizeHostFieldValue(value);
  return typeof normalized === 'string' ? normalized : '';
}

export function formStateToMultiSelect(raw: string | undefined): string[] {
  if (!raw) return [];
  return raw
    .split(',')
    .map((entry) => entry.trim())
    .filter((entry) => entry.length > 0);
}

export const MULTI_SELECT_BINDING_META: ComponentBindingMeta = {
  eventPropNames: ['onChange'],
  valuePropName: 'selectedValues',
  formKeyValueTransform: multiSelectToFormState,
  formStateValueTransform: formStateToMultiSelect,
};
